var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"imgRef",staticClass:"mt-2",staticStyle:{"display":"block"},attrs:{"src":_vm.bldgPhoto,"width":"100%","onLoad":"style.visibility='visible'"},on:{"error":_vm.imgHandler}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67faf921","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buildingcard/BldgPhoto.vue
// module id = null
// module chunks = 